import { z } from 'zod';
import { SearchSchema } from '@anytag/shared-validations';
import { defaultProfilePostsFilterSchema } from '@anytag/shared-organisms';

export const AnalyticsIgCommentsSearchSchema = SearchSchema.create({
  filter: defaultProfilePostsFilterSchema
});

export type AnalyticsIgCommentsSearchSchemaType = z.infer<typeof AnalyticsIgCommentsSearchSchema>;
